import { Button, Flex, rem, Text, Title } from "@mantine/core"
import FeaturedCheckIcon from "common/icons/featured-check"
import useCallignTime from "hooks/useCallingTime"
import { useGetCity } from "hooks/useRequest/location/location"
import { useUpdateProject } from "hooks/useRequest/project/projectRequest"
import Image from "next/image"
import { useRouter } from "next/router"
import { useCallback, useEffect } from "react"
import cityService from "services/city.service"
import LastProjectService from "services/last-project"





const PriceFormStepSuccess = () => {
    const city = cityService.getCity();

    const router = useRouter();


    const { data } = useGetCity({
        city: city?._id as string,
        enabled: Boolean(city?._id),
    });

    const consulationText = useCallignTime()

    const { mutate, isSuccess, isLoading } = useUpdateProject();

    const callToActionClickHandler = useCallback(() => {
        mutate({
            id: LastProjectService.getId(),
            data: {
                unstructuredData: "clickOnFormCallToAction",
                clicksOnContractorPageInLastFormStep: true
            }
        });
    }, []);

    useEffect(() => {
        if (isSuccess) {
            router.push(
                data?.data?.countOfContractors > 0
                    ?
                    city?.class ?
                        `/contractors/cities/${data?.data?.alias}?filters={"sortBaseOn":"usersRecommendation"}`
                        :
                        `/contractors/cities/${data?.data?.alias}?filters={"sortBaseOn":"usersRecommendation","canBeSelectByCustomer":"true"}`
                    : `/contractors?filters={"canBeSelectByCustomer":"true","sortBaseOn":"usersRecommendation"}`
            );
        }
    }, [isSuccess]);

    const textProps = {
        fz: { base: rem(12), sm: rem(14) },
        fw: 400,
        lh: { base: rem(18), sm: rem(21) },
    }


    return (
        <Flex
            direction="column"
            gap={32}
            w="100%"
            pos="relative"
            style={{
                overflow: "visible"
            }}
        >
            <Flex
                direction={{ base: "column", sm: "row" }}
                gap={8}
            >
                <Flex flex={2} direction="column" gap={16}>
                    <Flex gap={8} align="center" direction={{ base: "column", sm: "row" }} justify={{ base: "center", sm: "start" }}>
                        <FeaturedCheckIcon />
                        <Title
                            order={4}
                            fw={700}
                            fz={rem(16)}
                            lh={rem(24)}
                            c="success"
                        >
                            درخواست  شما با موفقیت ثبت شد
                        </Title>
                    </Flex>

                    <Flex align="center" direction="column">
                        <Flex justify="space-between" align="center" w="100%">
                            <Text {...textProps}>ساعت درخواست</Text>
                            <Text {...textProps}>{new Date().toLocaleDateString("fa-IR")}</Text>
                        </Flex>

                        <Flex justify="space-between" align="center" w="100%">
                            <Text {...textProps}>زمان تماس</Text>
                            <Text {...textProps}>{consulationText}</Text>
                        </Flex>
                    </Flex>

                    <Text {...textProps} lh={rem(21)} w="100%" style={{ textAlign: "justify" }}>
                        پیشنهاد می‌کنیم از لیست زیر، متخصص مورد نظر خود را انتخاب کنید و قرار بازدید رایگان بگذارید. همچنین منتظر بمانید مشاور سلام‌ساختمان به‌زودی با شما تماس می‌گیرد
                    </Text>

                    <Button
                        onClick={callToActionClickHandler}
                        loading={isLoading}
                    >
                        انتخاب متخصصین برتر {data?.data.countOfContractors > 0 ? data?.data?.name : ""}
                    </Button>

                </Flex>

                <Flex
                    visibleFrom="sm"
                    flex={1.5}
                    pos="relative"
                >
                    <Image
                        src="/images/models/instance-get-price.png"
                        alt="instance price"
                        layout="fill"
                        objectFit="contain"
                    />
                </Flex>
            </Flex>
        </Flex>
    )
}

export default PriceFormStepSuccess